module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button is-medium",
    on: {
      "click": _vm.snackbar
    }
  }, [_vm._v("\n            Launch snackbar (default)\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-warning",
    on: {
      "click": _vm.warning
    }
  }, [_vm._v("\n            Launch snackbar (custom)\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-danger",
    on: {
      "click": _vm.danger
    }
  }, [_vm._v("\n            Launch snackbar (custom)\n        ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab38233"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/snackbar/examples/ExSimple.vue
// module id = 1184
// module chunks = 40 97